import cloneDeep from 'lodash/cloneDeep';

import Base from 'app/models/base';
import Address from 'app/models/address';
import Tracker from 'app/models/tracker';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('insurances'),
  rootKey: 'insurance',

  parse(attributes) {
    const attrs = { rawJSON: cloneDeep(attributes), ...attributes };

    if (attrs.to_address) {
      attrs.to_address = new Address(attrs.to_address);
    }

    if (attrs.from_address) {
      attrs.from_address = new Address(attrs.from_address);
    }

    if (attrs.tracker) {
      attrs.tracker = new Tracker(attrs.tracker);
    }

    return attrs;
  },
});



// WEBPACK FOOTER //
// ./app/models/insurance.js